import { useApi } from '@/api';
import {
  Page,
  PageSkeleton,
  SparkTitle,
  Asset,
  WalletHeading
} from '@/components';
import { useParams } from 'react-router';
import WalletMarketEventsTable from './WalletMarketEventsTable';

type Market = {
  underlying_symbol: string;
  underlying_address: string;
  wallet_info: {
    total_supply: string | null;
    total_borrow: string | null;
    health_rate: string | null;
  };
};

export default function WalletMarketActivityPage() {
  const { marketAddress, walletAddress, network } = useParams() as {
    marketAddress: string;
    walletAddress: string;
    network: string;
  };

  const [data, error] = useApi<Market>({
    url: `/markets/${marketAddress}/wallets/${walletAddress}/`
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <PageSkeleton />;
  }
  return (
    <Page>
      <WalletHeading
        walletAddress={walletAddress}
        totalSupply={data.wallet_info.total_supply}
        totalBorrow={data.wallet_info.total_borrow}
        healthRate={data.wallet_info.health_rate}
        network={network}
        justify-content="center"
      />

      <SparkTitle>
        <Asset
          symbol={data.underlying_symbol}
          address={data.underlying_address}
          network={network}
          iconSize="4"
          fontSize="3"
        />
      </SparkTitle>
      <WalletMarketEventsTable
        network={network}
        marketAddress={marketAddress}
        walletAddress={walletAddress}
      />
    </Page>
  );
}
